import { render } from "./CheckServer.vue?vue&type=template&id=1c81571a&scoped=true"
import script from "./CheckServer.vue?vue&type=script&lang=js"
export * from "./CheckServer.vue?vue&type=script&lang=js"

import "./CheckServer.vue?vue&type=style&index=0&id=1c81571a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c81571a"]])

export default __exports__